import PropTypes from "prop-types";
import React, { useRef, useEffect, useContext } from "react";
import { useState } from "react";
import Moment from "react-moment";
import { updateScheduleRequest } from "../../../api/wordpress";
import { UserContext } from "../../../contexts/user.context";
import usePaystack from "../../../components/usePaystack";
import GenericModal from "../../../components/modals/generic-modal.component";

const Message = ({ message, myUserID, fullName, confirmMessageSchedule, confirmPayment, chat}) => {
  // const [loading, setLoading] = useState();
  const [loading, setLoading] = useState(false);
  const [showEscrowModal, setShowEscrowModal] = useState(false);
  const scrollRef = useRef();
  console.log(message,"message")
  // const [showPaymentWidget, setShowPaymentWidget] = useState(false);
  const isMessageALink =
  message.text.includes("https://") || message.text.includes("http://");
  const { user } = useContext(UserContext);
  
  const token = JSON.parse(localStorage.getItem("user"))?.token;
  const email = JSON.parse(localStorage.getItem("user"))?.user?.user_email;

  const confirmSchedule = async (status) => {
    try {
      setLoading(true);
      const transactionFormData = new FormData();
      transactionFormData.append("id", message.scheduleId);
      transactionFormData.append("schedule_status", status);
      transactionFormData.append("user_email", email);
      await updateScheduleRequest(token, transactionFormData);
      await confirmMessageSchedule(message.id, status);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  
  console.log(process.env.REACT_APP_BASE_URL || "https://ruumies-vfd-nodejs-engine-juft.vercel.app")
  const { startPayment } = usePaystack({
    initializeUrl: `${process.env.REACT_APP_BASE_URL || "https://ruumies-vfd-nodejs-engine-juft.vercel.app"}/api/payments/initialize`,
    onClientSuccess: (initResponse) => {
      console.log("initialized", initResponse);
    }
  });

  const rentAmount = Number(message.text) || 0;
  const ruumiesFee = Math.round(rentAmount * 0.01);
  const vat = Math.round(ruumiesFee * 0.075);
  const subtotal = rentAmount + ruumiesFee + vat;

  let paystackFee = 0;
  if (subtotal > 0) {
    if (subtotal < 2500) {
      paystackFee = (subtotal * 0.015) / (1 - 0.015);
    } else {
      paystackFee = ((subtotal * 0.015) + 100) / (1 - 0.015);
    }
    if (paystackFee > 2000) paystackFee = 2000;
    paystackFee = Math.ceil(paystackFee);
  }

  const totalToPay = subtotal + paystackFee;

  const handleClick = async () => {
    try {
      setLoading(true);
      const amountKobo = Math.round(totalToPay * 100); 
      const resp =  await startPayment({ 
        email, 
        amount: amountKobo, 
        metadata: {
          ...chat, 
          myUserID,
          messageId: message.id, 
          propertyId: message.propertyId,
          rentAmount: rentAmount,
          title: message.title || "Ruumies Property", 
          type: message.type || "",                   
          media: message.media || ""
        } 
      });
      console.log(resp)
      setShowEscrowModal(false);
    } catch (err) {
      console.error("payment failed to start", err);
      alert(err.message || "Payment failed to start");
    } finally {
      setLoading(false);
    }
  };

    const handlePayment = async(status)=>{
      if(status === "Agreed"){
        setShowEscrowModal(true);
      }else{
        await confirmPayment(message.id, status);
      }
    }
 

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [message]);
  return (
    <>
      {message.from !== myUserID ? (
        <li className="flex justify-start" ref={scrollRef}>
          {message.isSchedule != null && message.isSchedule === true ? (
            <div className="relative max-w-xl flex flex-col space-y-2 items-start">
              <p className="text-[#656565] text-[14px]">
                {fullName} just scheduled inspection
              </p>
              <div className="relative max-w-xl px-4 py-2 flex flex-row space-x-6 text-white bg-[#E9F2FF] rounded-xl rounded-tr-none shadow font-light">
                <span className="bg-white text-black text-[14px] md:text-[16px] py-2 px-2 rounded-[8px]">
                  {message.scheduleDate}
                </span>
                <span className="bg-white text-black text-[14px] md:text-[16px] py-2 px-2 rounded-[8px]">
                  {message.scheduleTime}
                </span>
              </div>
              {(message.isConfirmed != null && message.isConfirmed === true) ||
              myUserID === message.schedulePropertyOwnerId ? (
                <></>
              ) : (
                <>
                  <button
                    type="button"
                    onClick={() => confirmSchedule("Agreed")}
                    disabled={loading}
                    className="close-modal w-full inline-flex justify-center rounded-md border shadow-sm px-4 py-2 bg-primary text-base font-medium text-white border-primary hover:bg-transparent hover:text-primary hover:border-primary focus:outline-none focus:right-0  sm:ml-3 sm:w-auto sm:text-sm"
                  >
                    {loading ? (
                      <svg
                        role="status"
                        className="inline w-4 h-4 mr-3 text-white animate-spin"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="#E5E7EB"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentColor"
                        />
                      </svg>
                    ) : (
                      "Confirm"
                    )}
                  </button>
                  <button
                    type="button"
                    onClick={() => confirmSchedule("Closed")}
                    disabled={loading}
                    className="close-modal w-full inline-flex justify-center rounded-md border shadow-sm px-4 py-2 bg-red-700 text-base font-medium text-white border-red-700 hover:bg-transparent hover:text-red-700 hover:border-red-700 focus:outline-none focus:right-0  sm:ml-3 sm:w-auto sm:text-sm"
                   
                  >
                    {loading ? (
                      <svg
                        role="status"
                        className="inline w-4 h-4 mr-3 text-white animate-spin"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="#E5E7EB"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentColor"
                        />
                      </svg>
                    ) : (
                      "Reject"
                    )}
                  </button>
                </>
              )}
            </div>
          ) : message.isPayment ? (
            <div className="relative max-w-xl flex flex-col space-y-2 items-end">
              
              <div className="relative max-w-xl px-4 py-2 flex flex-row space-x-6 text-white bg-[#E9F2FF] rounded-xl rounded-tr-none shadow font-light">
                <span className="bg-white text-black text-[14px] md:text-[16px] py-2 px-2 rounded-[8px]">
                  A  Payment {message.isConfirmed? '': 'Request'}  of ₦{Number(message.text).toLocaleString()} was {message.isRejected ? 'cancelled' :'made'} for {message.title} {message.type}
                </span>
                
              </div>
              {(message.isConfirmed !== true && message.isRejected !== true) &&
              
                <>
                
                  <button
                    type="button"
                    onClick={() => handlePayment("Agreed")}
                    disabled={loading}
                    className="close-modal w-full inline-flex justify-center rounded-md border shadow-sm px-4 py-2 bg-primary text-base font-medium text-white border-primary hover:bg-transparent hover:text-primary hover:border-primary focus:outline-none focus:right-0  sm:ml-3 sm:w-auto sm:text-sm"
                  >
                    {loading ? (
                      <svg
                        role="status"
                        className="inline w-4 h-4 mr-3 text-white animate-spin"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="#E5E7EB"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentColor"
                        />
                      </svg>
                    ) : (
                      "Pay"
                    )}
                  </button>
                
                  <button
                    type="button"
                    onClick={() => handlePayment("Closed")}
                    disabled={loading}
                    className="close-modal w-full inline-flex justify-center rounded-md border shadow-sm px-4 py-2 bg-red-700 text-base font-medium text-white border-red-700 hover:bg-transparent hover:text-red-700 hover:border-red-700 focus:outline-none focus:right-0  sm:ml-3 sm:w-auto sm:text-sm"
                  >
                    {loading ? (
                      <svg
                        role="status"
                        className="inline w-4 h-4 mr-3 text-white animate-spin"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="#E5E7EB"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentColor"
                        />
                      </svg>
                    ) : (
                      user.viewing_as === "owner"? "Cancel" :"Reject"
                    )}
                  </button>
                </>
              }
            </div>
          ) : (
            <div className="relative max-w-xl px-[12px] py-[16px] text-gray-700 rounded-xl rounded-bl-none shadow bg-gray-100 font-light">
              <span className="block">
                {message.media ? (
                  <img
                    src={message.media}
                    alt={message.text}
                    className="w-52 h-52"
                  />
                ) : null}
                {isMessageALink ? (
                  <a
                    href={message.text}
                    target="_blank"
                    rel="noreferrer"
                    className="text-secondary"
                  >
                    {message.text}
                  </a>
                ) : (
                  message.text
                )}
                <br />
                <small className="text-xs">
                  <Moment fromNow>{message.createdAt.toDate()}</Moment>
                </small>
              </span>
            </div>
          )}
        </li>
      ) : (
        <li className="flex justify-end" ref={scrollRef}>
          {message.isSchedule != null && message.isSchedule === true ? (
            <div className="relative max-w-xl flex flex-col space-y-2 items-end">
              <p className="text-[#656565] text-[14px]">
                You just scheduled inspection
              </p>
              <div className="relative max-w-xl px-4 py-2 flex flex-row space-x-6 text-white bg-[#E9F2FF] rounded-xl rounded-tr-none shadow font-light">
                <span className="bg-white text-black text-[14px] md:text-[16px] py-2 px-2 rounded-[8px]">
                  {message.scheduleDate}
                </span>
                <span className="bg-white text-black text-[14px] md:text-[16px] py-2 px-2 rounded-[8px]">
                  {message.scheduleTime}
                </span>
              </div>
              {(message.isConfirmed != null && message.isConfirmed === true) ||
              myUserID === message.schedulePropertyOwnerId ? (
                <></>
              ) : (
                <>
                {
                   user.viewing_as !== "owner" &&
                  <button
                    type="button"
                    onClick={() => confirmSchedule("Agreed")}
                    disabled={loading}
                    className="close-modal w-full inline-flex justify-center rounded-md border shadow-sm px-4 py-2 bg-primary text-base font-medium text-white border-primary hover:bg-transparent hover:text-primary hover:border-primary focus:outline-none focus:right-0  sm:ml-3 sm:w-auto sm:text-sm"
                  >
                    {loading ? (
                      <svg
                        role="status"
                        className="inline w-4 h-4 mr-3 text-white animate-spin"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="#E5E7EB"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentColor"
                        />
                      </svg>
                    ) : (
                      "Confirm"
                    )}
                  </button>
                }
                  <button
                    type="button"
                    onClick={() => confirmSchedule("Closed")}
                    disabled={loading}
                    className="close-modal w-full inline-flex justify-center rounded-md border shadow-sm px-4 py-2 bg-red-700 text-base font-medium text-white border-red-700 hover:bg-transparent hover:text-red-700 hover:border-red-700 focus:outline-none focus:right-0  sm:ml-3 sm:w-auto sm:text-sm"
                  >
                    {loading ? (
                      <svg
                        role="status"
                        className="inline w-4 h-4 mr-3 text-white animate-spin"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="#E5E7EB"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentColor"
                        />
                      </svg>
                    ) : (
                      user.viewing_as === "owner"? "Cancel" :"Reject"
                    )}
                  </button>
                </>
              )}
            </div>
          ) : message.isPayment ? (
             <div className="relative max-w-xl flex flex-col space-y-2 items-end">
              
              <div className="relative max-w-xl px-4 py-2 flex flex-row space-x-6 text-white bg-[#E9F2FF] rounded-xl rounded-tr-none shadow font-light">
                <span className="bg-white text-black text-[14px] md:text-[16px] py-2 px-2 rounded-[8px]">
                  A  Payment Request of  ₦{Number(message.text).toLocaleString()} was {message.isRejected ? 'cancelled' :'made'} for {message.title} {message.type}
                </span>
                
              </div>
              {(message.isConfirmed !== true && message.isRejected !== true)  &&
             
                <>
             
                  <button
                    type="button"
                    onClick={() => handlePayment("Closed")}
                    disabled={loading}
                    className="close-modal w-full inline-flex justify-center rounded-md border shadow-sm px-4 py-2 bg-red-700 text-base font-medium text-white border-red-700 hover:bg-transparent hover:text-red-700 hover:border-red-700 focus:outline-none focus:right-0  sm:ml-3 sm:w-auto sm:text-sm"
                  >
                    {loading ? (
                      <svg
                        role="status"
                        className="inline w-4 h-4 mr-3 text-white animate-spin"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="#E5E7EB"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentColor"
                        />
                      </svg>
                    ) : (
                     "Cancel"
                    )}
                  </button>
                </>
              }
            </div>
          ) : (
            <div className="relative max-w-xl px-[12px] py-[16px] text-gray-700 rounded-xl rounded-bl-none shadow bg-gray-100 font-light">
              <span className="block">
                {message.media ? (
                  <img
                    src={message.media}
                    alt={message.text}
                    className="w-52 h-52"
                  />
                ) : null}
                {isMessageALink ? (
                  <a
                    href={message.text}
                    target="_blank"
                    rel="noreferrer"
                    className="text-secondary"
                  >
                    {message.text}
                  </a>
                ) : (
                  message.text
                )}
                <br />
                <small className="text-xs">
                  <Moment fromNow>{message.createdAt.toDate()}</Moment>
                </small>
              </span>
            </div>
          )}
        </li>
      )}

      {showEscrowModal && (
        <GenericModal
          onClick={(event) => {
            if (event.target.classList.contains("close-modal")) {
              setShowEscrowModal(false);
            }
          }}
          modalState={true}
        >
          <div className="bg-white w-full md:w-[500px] p-6 text-left rounded-lg text-gray-800">
            <h2 className="text-xl font-semibold mb-4 border-b pb-2 text-primary">Secure Your Ruum</h2>

            <div className="mb-6 bg-gray-50 p-4 rounded-md">
              <h3 className="text-sm font-semibold mb-2 text-gray-500 uppercase tracking-wider">Payment Breakdown</h3>
              <div className="flex justify-between text-sm mb-1">
                <span>Rent:</span>
                <span className="font-medium">₦{rentAmount.toLocaleString()}</span>
              </div>
              <div className="flex justify-between text-sm mb-1">
                <span>Service Charge (1%):</span>
                <span className="font-medium">₦{ruumiesFee.toLocaleString()}</span>
              </div>
              <div className="flex justify-between text-sm mb-1">
                <span>VAT:</span>
                <span className="font-medium">₦{vat.toLocaleString()}</span>
              </div>
              <div className="flex justify-between text-sm mb-3">
                <span>Payment Processing Fee:</span>
                <span className="font-medium">₦{paystackFee.toLocaleString()}</span>
              </div>
              <div className="flex justify-between text-lg font-bold border-t pt-2 border-gray-200">
                <span>Total to Pay:</span>
                <span className="text-primary">₦{totalToPay.toLocaleString()}</span>
              </div>
            </div>

            <div className="mb-8 text-sm text-gray-600 space-y-4">
              <h3 className="font-semibold text-gray-800 mb-3">Why Pay Through Ruumies?</h3>
              <p className="flex items-start leading-relaxed bg-blue-50  p-3 rounded-r-md">
                <span className="text-blue-600 mr-2 mt-0.5 text-lg font-bold">✔</span> 
                <span><strong className="text-blue-900">100% Secure Escrow:</strong> <span className="text-gray-700">Your money is held safely and only released after you confirm your move-in.</span></span>
              </p>
              <p className="flex items-start leading-relaxed">
                <span className="text-green-500 mr-2 mt-0.5">✔</span> 
                <span><strong>7-Day Grace Period:</strong> You have exactly 7 days to move in and confirm.</span>
              </p>
              <p className="flex items-start leading-relaxed">
                <span className="text-yellow-600 mr-2 mt-0.5">⚠</span> 
                
                <span><strong>Strict Cancellations:</strong> Cancellations are strongly discouraged as the cancelling party shall be liable for any resulting costs or financial obligations.</span>
              </p>
            </div>

            <div className="flex justify-end gap-4 mt-4">
              <button 
                className="close-modal px-4 py-2 border border-gray-300 rounded-lg text-gray-600 hover:bg-gray-100" 
                disabled={loading} 
                onClick={() => setShowEscrowModal(false)}
              >
                Cancel
              </button>
              <button 
                className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 flex items-center" 
                disabled={loading} 
                onClick={handleClick} 
              >
                {loading ? "Processing..." : "I Agree, Proceed to Payment"}
              </button>
            </div>
          </div>
        </GenericModal>
      )}
    </>
  );
};

Message.propTypes = {
  message: PropTypes.shape({
    text: PropTypes.string.isRequired,
    scheduleId: PropTypes.string,
    id: PropTypes.string,
    from: PropTypes.string.isRequired,
    isSchedule: PropTypes.bool,
    scheduleDate: PropTypes.string,
    scheduleTime: PropTypes.string,
    isConfirmed: PropTypes.bool,
    schedulePropertyOwnerId: PropTypes.string,
    media: PropTypes.string,
    createdAt: PropTypes.object.isRequired,
  }).isRequired,
  myUserID: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  confirmMessageSchedule: PropTypes.func.isRequired,
};

export default Message;